/**
 *
 * @param {Object / Array}  context       The object / array to search for nested properties on
 * @param {string}          varString     The string representing nested properties, egs:
 *                                          - 'foo'
 *                                          - 'foo.bar'      nested prop
 *                                          - "foo.0.bar"    look for arrays this way: equivalent to `foo[0].bar` in plain JS
 *                                          - 'foo'
 *
 * Returns: the nested prop value if found, or `undefined` if not
 *
 */
const getNestedProp = (context, varString) => {
  const splitVars = varString.split('.');
  const finalValue = splitVars.reduce((currentParent, prop) => {
    if (currentParent !== null && currentParent !== void 0 && currentParent[prop]) {
      return currentParent[prop];
    }

    return undefined;
  }, context);
  return finalValue;
};

export default getNestedProp;